import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MmButtonModule,
  MmFlexLayoutModule,
  MmPaginatorModule,
  MmIconModule,
  MmChipModule,
} from '@metromarkets/components';
import { QaLocatorsModule } from '@metromarkets/sdk';
import { TranslateModule } from '@ngx-translate/core';
import { FlexModule } from '@angular/flex-layout';

import { KebabCaseModule } from '~shared/pipes';

import { BasePageModule } from '~shared/modules/base-page/base-page.module';

import { BreadcrumbsModule } from '~shared/components/breadcrumbs/breadcrumbs.module';

import { BrandPLPRoutingModule } from './brand-plp.routing.module';
import { PageLoadingModule } from '~shared/components/page-loading/page-loading.module';
import {
  BrandPLPComponent,
  ProductListComponent,
  BrandPLPBodyComponent,
  BrandInfoComponent,
  BrandPlpActionsComponent,
  SortTogglerComponent,
  BrandPlpLoadingComponent,
} from './components';
import { StoreModule } from '@ngrx/store';
import { BRAND_PLP_FEATURE_NAME } from './store/feature-name';
import { ProductsEffects, BrandInfoEffects, brandPLPReducers, SortEffects } from './store';
import { EffectsModule } from '@ngrx/effects';

import { MmExpansionModule } from '~shared/modules/mm-expansion/mm-expansion.module';
import { ProductsGridModule } from '~shared/modules/products-grid/products-grid.module';
import { FiltersModule } from '~app/modules/filters/filters.module';

import { MmSelectModule } from '~shared/modules/mm-select/mm-select.module';
import { StickyModule } from '~shared/directives/sticky/sticky.module';
import { SeoModule } from '~shared/modules/seo/seo.module';
import { ZeroResultComponent } from '~app/modules/brand-plp/components';
import { ImageHeaderModule } from '~shared/components/image-header/image-header.module';
import { IsVisibleModule } from '~shared/directives/is-visible/is-visible.module';
import { TooltipModule } from '~shared/modules/tooltip/tooltip.module';
import { DynamicModule } from 'ng-dynamic-component';
import { StoryblokEditableModule } from '~app/modules/storyblok/directives/storyblok-editable/storyblok-editable.module';
import { VatDisclaimerPLPs } from '~shared/components/vat-disclaimer-plps';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { FilterFacetsCarouselModule } from '~shared/modules/catalog';
import { StoryblokSeoModule } from '~shared/modules/storyblok-seo/storyblok-seo.module';
import { StoryblokModule } from '../storyblok/storyblok.module';
import { CategoryFacetsCarouselModule } from '~shared/components/category-facets-carousel/category-facets.module';


@NgModule({
  declarations: [
    BrandPLPComponent,
    ProductListComponent,
    BrandPLPBodyComponent,
    BrandInfoComponent,
    BrandPlpActionsComponent,
    SortTogglerComponent,
    ZeroResultComponent,
    BrandPlpLoadingComponent,
  ],
  imports: [
    CommonModule,
    BrandPLPRoutingModule,
    StoreModule.forFeature(BRAND_PLP_FEATURE_NAME, brandPLPReducers),
    EffectsModule.forFeature([ProductsEffects, BrandInfoEffects, SortEffects]),
    MmFlexLayoutModule,
    MmPaginatorModule,
    TranslateModule,
    QaLocatorsModule,
    KebabCaseModule,
    BasePageModule,
    BreadcrumbsModule,
    FlexModule,
    MmExpansionModule,
    ProductsGridModule,
    FiltersModule,
    MmSelectModule,
    StickyModule,
    MmIconModule,
    PageLoadingModule,
    MmButtonModule,
    MmChipModule,
    StoryblokSeoModule,
    SeoModule,
    ImageHeaderModule,
    IsVisibleModule,
    TooltipModule,
    DynamicModule,
    StoryblokEditableModule,
    VatDisclaimerPLPs,
    NgxSkeletonLoaderModule,
    FilterFacetsCarouselModule,
    StoryblokModule,
    CategoryFacetsCarouselModule
  ]
})
export class BrandPLPModule {}
